import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { toast } from 'react-toastify';
import { api } from '../../../APIs/api';
import { API_URL, BASE_URL } from '../../../APIs/endpoint';
import ReviewCardComponent from './ReviewCommonCard';

const GlobalReviewsSection = () => {
  const [reviewData, setReviewData] = useState([]);
  const [isLoader, setIsLoader] = useState(false);

  useEffect(() => {
    const getReviewListApi = async () => {
      try {
        setIsLoader(true);
        const reviewRes = await api.get(`${BASE_URL}${API_URL.REVIEW_LIST}`);
        const { data, message, status } = reviewRes;
        if (status) {
          setReviewData(data);
        } else {
          toast.error(message, { autoClose: 3000 });
        }
      } catch (err) {
        toast.error(err.message, { autoClose: 3000 });
      } finally {
        setIsLoader(false);
      }
    };

    getReviewListApi();
  }, []);

  return (
    <Box id="reviewCard" sx={{ width: '100%', mb: 4 }}>
      <ReviewCardComponent reviewData={reviewData} isLoader={isLoader} />
    </Box>
  );
};

export default GlobalReviewsSection;
